const actions = {
  CHANGE_PASSWORD_BEGIN: 'CHANGE_PASSWORD_BEGIN',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_ERR: 'CHANGE_PASSWORD_ERR',

  ADMIN_UPDATE_BEGIN: 'ADMIN_UPDATE_BEGIN',
  ADMIN_UPDATE_SUCCESS: 'ADMIN_UPDATE_SUCCESS',
  ADMIN_UPDATE_ERR: 'ADMIN_UPDATE_ERR',

  RESET_PASSWORD_BEGIN: 'RESET_PASSWORD_BEGIN',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERR: 'RESET_PASSWORD_ERR',

  adminUpdateBegin: () => {
    return {
      type: actions.ADMIN_UPDATE_BEGIN,
    };
  },

  adminUpdateSuccess: (data) => {
    return {
      type: actions.ADMIN_UPDATE_SUCCESS,
      data,
    };
  },

  adminUpdateErr: (err) => {
    return {
      type: actions.ADMIN_UPDATE_ERR,
      err,
    };
  },

  changePasswordBegin: () => {
    return {
      type: actions.CHANGE_PASSWORD_BEGIN,
    };
  },

  changePasswordSuccess: (data) => {
    return {
      type: actions.CHANGE_PASSWORD_SUCCESS,
      data,
    };
  },

  changePasswordErr: (err) => {
    return {
      type: actions.CHANGE_PASSWORD_ERR,
      err,
    };
  },

  resetPasswordBegin: () => {
    return {
      type: actions.RESET_PASSWORD_BEGIN,
    };
  },

  resetPasswordSuccess: (data) => {
    return {
      type: actions.RESET_PASSWORD_SUCCESS,
      data,
    };
  },

  resetPasswordErr: (err) => {
    return {
      type: actions.RESET_PASSWORD_ERR,
      err,
    };
  },
      
};

export default actions;
